import React, { memo } from "react";
import { GolContactTextFieldProps } from "./gol-contact-form-interfaces";
import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import styled from "styled-components";

const CustomTextField = styled(TextField)`
  input[type="date"] {
    color: ${(props) => props.theme.textColor};
    font-size: 0.8em;
    margin-bottom: 4px;
    padding: 10px;
  }
  input::placeholder {
    font-size: 12px;
  }
`;

const GolContactTextField = memo((props: GolContactTextFieldProps) => {
  const {
    multiline = false,
    rows = 1,
    rowsMax = 1,
    inputLabelProps = {},
    fullWidth = false,
    label,
    value,
    placeholder,
    clazz,
    onChange,
    name,
    inputProps = {},
    textSize = "small",
    type = "text",
  } = props;
  return (
    <CustomTextField
      size={textSize}
      name={name}
      onChange={onChange}
      type={type}
      className={clazz}
      defaultValue={value}
      label={label}
      placeholder={placeholder}
      variant={"outlined"}
      multiline={multiline}
      rows={rows}
      rowsMax={rowsMax}
      fullWidth={fullWidth}
      inputProps={inputProps}
      InputLabelProps={inputLabelProps}
    />
  );
});

export { GolContactTextField };
